<template>
    <div class="modal-container cmnmodel">
        <div class="modal-dialog modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                
                <div class="modal-header"><h5 class="modal-title">  {{header}}</h5><a class="modal-close" @click="$emit('cancel')"><i class="fa fa-times"></i></a></div>
                <div class="modal-body">
                    {{ question }}
                </div>
                <div class="modal-footer">
                    <button class="btn btn-pill btn-gradient color-4" @click="$emit('confirm')" style="min-width:100px">{{confirm}}</button>
                    <button class="btn btn-pill btn-dashed color-4" @click="$emit('cancel','onCancel')">{{cancel}}</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import { defineComponent } from "vue";

    export default defineComponent({
        props: ["question", "header", "cancel", "confirm"],
        emits: ["confirm", "cancel","onCancel"],
    });

</script>

<style>
    
   
</style>